import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-edfd99a2")

_pushScopeId("data-v-edfd99a2")
const _hoisted_1 = { class: "contact-item" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = {
  key: 0,
  class: "btns"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", { class: _ctx.itemClasses }, [
      (_ctx.type === 'inCall')
        ? (_openBlock(), _createBlock("div", {
            class: "emoji",
            key: _ctx.lastEmoji
          }, [
            _createVNode("span", { class: _ctx.emojiClass }, _toDisplayString(_ctx.lastEmoji), 3)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isContact)
        ? (_openBlock(), _createBlock("img", {
            key: 1,
            class: "avatar",
            src: _ctx.image,
            alt: "avatar"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.item), 1)
    ], 2),
    (_ctx.type === 'inCall')
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_Icon, {
            spriteUrl: "/image/videoconf-icons.svg",
            name: _ctx.iconMicName,
            color: "--sui-gray-700"
          }, null, 8, ["name"]),
          _createVNode(_component_Icon, {
            spriteUrl: "/image/videoconf-icons.svg",
            name: _ctx.iconCamName,
            color: "--sui-gray-700"
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true)
  ]))
})